

 <nb-card class="modalCard" *ngIf="!loading && state === 'done'" >
  <nb-card-header>



 <div style="display:flex; width:100%;">
                <span style="margin-right:20px;">  {{ isEnglish ? 'Successfull payment!' : 'Оплата пройшла успішно'}}</span>
                 <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="closeMainModal()">
			<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
		</span>
                </div>
           </nb-card-header>
           	<nb-card-body >
		<div class="success-animation">
<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" /><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
</div>





		     <p class="text-center">{{ isEnglish ? 'Your key' : 'Ваш код доступу'}}</p>
		     <p class="text-center" style="font-size:18px; line-height: 30px; position:relative; "><b>{{buyedCode}}</b> <span  (cbOnSuccess)="showToastCopyClipboard('Скопійовано в буфер обміну')"
                ngxClipboard [cbContent]="buyedCode" style="margin-left:10px;   color: #ccc;  cursor: pointer; position:absolute;"> <i class="fa fa-copy"></i></span></p>
		     <p class="text-center">{{ isEnglish ? 'The key has also been sent to your email' : 'Код також надіслано на ваш email'}}</p>
		     <ng-container *ngIf="unlocked">
			     <p class="text-center">{{ isEnglish ? 'Access is open on this page. Keep the key to watch on another device.' : 'Доступ на цій сторінці вже відкрито. Збережіть код, щоб дивитися на іншому пристрої.' }}</p>
			     <div class="doneActions">
				     <button nbButton status="primary" (click)="closeMainModal()">{{ isEnglish ? 'Watch' : 'Дивитися' }}<span *ngIf="closeIn > 0">&nbsp;({{closeIn}})</span></button>
			     </div>
		     </ng-container>
        	</nb-card-body>
 </nb-card>


<!-- The bank's own payment page, framed. Everything that follows a card number
     being typed happens here; the modal only watches the order.

     Sized in viewport units rather than pixels: on a phone a fixed 640px frame
     plus a header and a footer does not fit, and the part that gets cut off is
     always the pay button. -->
 <nb-card class="payCard" *ngIf="state === 'paying'" >
           <nb-card-header>

 <div style="display:flex; width:100%;">
                <span style="margin-right:20px;">{{ isEnglish ? 'Payment' : 'Оплата'}}</span>
                 <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="closeMainModal()">
			<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
		</span>
                </div>
           </nb-card-header>
		<nb-card-body class="payBody">


			<!-- Shown only when nothing has happened for a while. The two ways out it
			     offers both keep the buyer on this page. -->
			<div class="payHelp" *ngIf="showHelp">
				<div class="payHelpTitle">{{ isEnglish ? 'Payment not going through?' : 'Оплата не завершується?' }}</div>
				<p class="payHelpText">
					{{ isEnglish
						? 'Pay from the monobank app with mono Pay, or open the payment page in its own window — the order stays here either way.'
						: 'Оплатіть через mono Pay у застосунку monobank або відкрийте сторінку оплати в окремому вікні — замовлення залишиться тут.' }}
				</p>
				<a class="payHelpLink" href="javascript:;" (click)="openInWindow()">
					{{ isEnglish ? 'Open in a new window' : 'Відкрити в новому вікні' }}
				</a>
			</div>

			<iframe *ngIf="payUrl" [src]="payUrl" title="payment"
				[class.withHelp]="showHelp"
				class="payFrame"
				allow="payment *"></iframe>
		</nb-card-body>
		<nb-card-footer class="payFooter">
			<a href="javascript:;" *ngIf="!showHelp" (click)="openInWindow()">{{ isEnglish ? 'Open in a new window' : 'Відкрити в новому вікні'}}</a>
			<a href="javascript:;" class="footerBack" (click)="backToForm()">{{ isEnglish ? 'Back' : 'Назад'}}</a>
		</nb-card-footer>
 </nb-card>


 <nb-card class="modalCard" *ngIf="state === 'waiting'" >
           <nb-card-header>

 <div style="display:flex; width:100%;">
                <span style="margin-right:20px;">{{ isEnglish ? 'Confirming payment' : 'Підтверджуємо оплату'}}</span>
                 <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="closeMainModal()">
			<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
		</span>
                </div>
           </nb-card-header>
           	<nb-card-body >

			 <div  style="display: flex; width:100%; margin-top:35px;">
			    <div style="display: flex; margin: auto;">

				 <app-loader></app-loader>
			     </div>
			    </div>

			<p class="text-center" style="margin-top:25px; font-size:13px; color:#8f9bb3;">
				{{ isEnglish ? 'This takes a few seconds. The key will also be sent to your email.' : 'Це займає кілька секунд. Код також надійде на ваш email.'}}</p>
        	</nb-card-body>
 </nb-card>


 <nb-card class="modalCard" *ngIf="state === 'failed'" >
           <nb-card-header>

 <div style="display:flex; width:100%;">
                <span style="margin-right:20px;">{{ isEnglish ? 'Payment unavailable' : 'Оплата недоступна'}}</span>
                 <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="closeMainModal()">
			<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
		</span>
                </div>
           </nb-card-header>
           	<nb-card-body >
		<p class="text-center" style="margin-top:10px;">{{failMessage}}</p>
		<div style="margin-top:20px; display:flex">
			<div style="margin:auto; display:flex">
				<button nbButton status="default" (click)="closeMainModal()">{{ isEnglish ? 'Close' : 'Закрити'}}</button>
			</div>
		</div>
        	</nb-card-body>
 </nb-card>


 <nb-card class="modalCard" *ngIf="!loading && state === 'form'" >
           <nb-card-header>

 <div style="display:flex; width:100%;">
                <span style="margin-right:20px;">{{ isEnglish ? 'Buy access key' : 'Покупка доступу'}}</span>
                 <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="closeMainModal()">
			<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
		</span>
                </div>
           </nb-card-header>
           	<nb-card-body >
	 	<p> {{ isEnglish ? 'Where to send the key?' : 'Куди відправити код?'}}</p>

		<label>{{ isEnglish ? 'Email*' : 'На email'}}</label>
		<div><input [class.borderError]="error" (change)="emailChange()"  nbInput  fullWidth [(ngModel)]="email" name="email"
		 placeholder="{{ isEnglish ? 'Your email *' : 'Введіть email *'}}  " /> </div>
		<br/>
		<label>{{ isEnglish ? 'SMS' : 'SMS на телефон'}}</label>
		<div><input   nbInput  fullWidth [(ngModel)]="phone" name="phone"
		 placeholder="{{ isEnglish ? 'Phone number' : 'Введіть номер телефону'}} " /> </div>
	<div style="font-size:12px;">{{ isEnglish ? 'For example: +1234567890' : 'Приклад: +380991234567'}}</div>



		<div style="margin-top:15px; display:flex">
			<div style="margin-left:auto; display:flex">
			<button nbButton status="primary" [disabled]="!isValidEmail" (click)="pay()">{{ isEnglish ? 'Go To Payment' : 'Перейти до оплати'}}</button>

			</div>
			</div>




        	</nb-card-body>
 </nb-card>


    <div *ngIf="loading" style=" position:fixed; z-index: 7777; width:100%; height:100%; top:0; left: 0; display: flex; ">
    <div style="display: flex; margin: auto;">

         <app-loader></app-loader>
     </div>
    </div>
